/** Where the build emits the service worker (vite.config.ts). */
export const SW_URL = '/sw.js';

interface Host {
  isSecureContext: boolean;
  navigator: Navigator;
  addEventListener: Window['addEventListener'];
  document: Document;
}

/**
 * Registers the app-shell service worker: only in production builds and only
 * in a secure context (HTTPS or localhost), where browsers allow it. Returns
 * whether registration was attempted. Failures are ignored: the app works the
 * same without it, only without the fast start.
 */
export function registerServiceWorker(prod: boolean, host: Host = window): boolean {
  if (!prod || !host.isSecureContext || !('serviceWorker' in host.navigator)) return false;
  const register = () => {
    host.navigator.serviceWorker.register(SW_URL, { scope: '/' }).catch(() => undefined);
  };
  // After the page has loaded, so the first visit is not slowed down.
  if (host.document.readyState === 'complete') register();
  else host.addEventListener('load', register, { once: true });
  return true;
}
